import { forwardRef, type ButtonHTMLAttributes } from 'react';

import clsx from 'clsx';

import styles from './styles.module.css';

type Props = ButtonHTMLAttributes<HTMLButtonElement>;

export const ButtonMinimal = forwardRef<HTMLButtonElement, Props>(
  function ButtonMinimal({ className, children, ...rest }, ref) {
    return (
      <button
        {...rest}
        className={clsx(styles.buttonMinimal, className)}
        ref={ref}
      >
        {children}
      </button>
    );
  }
);
